import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Sayfa Bulunamadı</h1>
        <p>Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
        <div className="error-actions">
          <Link to="/" className="home-button">
            🏠 Ana Sayfaya Dön
          </Link>
        </div>
        <div className="error-suggestions">
          <h3>Belki şunları arıyorsunuz:</h3>
          <ul>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to="/analytics">Analitikler</Link></li>
            <li><Link to="/settings">Ayarlar</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
